<div class="heading">
  @if (loading) {
    <div class="skeleton img-skeleton"></div>

    <div class="skeleton title-skeleton" style="width: 15rem; height: 1.3rem;"></div>

    <div class="info-icon-button-wrapper invisible"></div>
  }
  @else {
    @if (image && !imageLoadError()) {
      <img
        src="{{ image }}"
        (load)="imageLoadError.set(false)"
        (error)="imageLoadError.set(true)"
      >
    }
    @else if (placeholderIcon) {
      <div class="placeholder-icon-wrapper">
        <mat-icon class="material-symbols-outlined placeholder-icon">
          {{ placeholderIcon }}
        </mat-icon>
      </div>
    }
    @else {
      <div class="placeholder-icon-wrapper">
        <mat-icon class="material-symbols-outlined placeholder-icon">
          image
        </mat-icon>
      </div>
    }

    <span
      class="title"
      [innerHTML]="title"
    ></span>

    @if (infoMenuContent.childElementCount > 0) {
      <div
        class="info-icon-button-wrapper"
        [class.invisible]="hideInfoPopover"
      >
        <button
          class="info-icon-button"
          mat-icon-button
          type="button"
          [matMenuTriggerFor]="infoMenu"
        >
          <mat-icon class="material-symbols-outlined info-icon">
            info
          </mat-icon>
        </button>
      </div>
    }

    <mat-menu
      #infoMenu="matMenu"
      class="object-page-header__information-popover-mat-menu"
    >
      <div #infoMenuContent>
        <ng-content select="[slot=information-popover-content]"></ng-content>
      </div>
    </mat-menu>
  }
</div>
